<mat-card id='table-header'>
  <mat-toolbar class="toolbar-top">
    <div class='title'>
      <mat-icon>apps</mat-icon>
      <div>Painel</div>
    </div>
  </mat-toolbar>
</mat-card>


<div *ngIf='_authService.isAdmin'>

  <!--
  <button (click)="loadAgenda()">
    check agenda
  </button>

  <mat-card>
    <div class='card-title'>Inscrições - Origem</div>
    <div *ngFor='let allPieChart of _dashService.allOriginPieCharts'>
      <google-chart [data]="allPieChart"></google-chart>
    </div>
  </mat-card>

 
  <mat-card>
    <div class='card-title'>Inscrições - Valor</div>
    <div *ngFor='let valuePieChart of _dashService.allValuesPieCharts'>
      <google-chart [data]="valuePieChart"></google-chart>
    </div>
  </mat-card>
-->

  <!--
    <mat-card>
        <div class='card-title'>Inscrições - Categorias</div>
        <div *ngFor='let catPieChart of _dashService.allCategoriesPieCharts'>
            <google-chart [data]="catPieChart"></google-chart>
        </div>
    </mat-card>
    -->

  <mat-card>
    <div class='card-title'>Movimentação ( últimos dois dias )</div>

    <mat-table [dataSource]="lastesdOrdersDataSource" style='height:200px; overflow:auto; margin: 10px 0 0 0;'>

      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef> Data </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.date | date: 'dd/MM/yyyy'}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="member">
        <mat-header-cell *matHeaderCellDef> Usuário </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.member_name }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="product">
        <mat-header-cell *matHeaderCellDef> Produto/Anuidade </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.product_name }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="origin">
        <mat-header-cell *matHeaderCellDef> Origem </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.origin }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef> Tipo </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.type }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="total">
        <mat-header-cell *matHeaderCellDef> Total </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.total | currency:'BRL':'':'1.2-2' }}
        </mat-cell>
      </ng-container>

      <mat-header-row class='mat-header-row' *matHeaderRowDef="lastesdOrdersColumns">
      </mat-header-row>

      <mat-row *matRowDef="let row; columns: lastesdOrdersColumns;">
      </mat-row>

    </mat-table>
    <!-- END TABLE -->
  </mat-card>

  <mat-card>
    <div class='card-title'>Anotações Pendentes</div>

    <!-- TABLE -->
    <mat-table [dataSource]="annotationDataSource" matSort matSortActive="date"
      style='height:200px; overflow:auto; margin: 10px 0 0 0;'>

      <!-- data Column -->
      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Data </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.date | date: 'dd/MM/yyyy'}}
        </mat-cell>
      </ng-container>

      <!-- texto Column -->
      <ng-container matColumnDef="text">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Texto </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div style="display:flex; flex-direction: column;">
            <div>
              <b>{{ element.member_name }}</b>
            </div>
            <div>
              {{ element.text }}
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <!-- status Column -->
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Texto </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span *ngIf='element.status === 0'>
            <img src='/assets/images/status/img_silver.png'>
          </span>
          <span *ngIf='element.status === 1'>
            <img src='/assets/images/status/img_red.png'>
          </span>
          <span *ngIf='element.status === 2'>
            <img src='/assets/images/status/img_green.png'>
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='openAnnotationDialog(element)' style='background-color: whitesmoke;'>
            <mat-icon class='icon-info' style='font-size:1.5em;'>
              info_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="delete">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='deleteAnnotation(element)' style='background-color: whitesmoke;'>
            <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>

      <!-- Header -->
      <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedAnnotationColumns">
      </mat-header-row>

      <!-- Row -->
      <mat-row *matRowDef="let row; columns: displayedAnnotationColumns;">
      </mat-row>

    </mat-table>
    <!-- END TABLE -->
  </mat-card>

  <mat-card>
    <div class='card-title'>Alterações de Dados Vindas do Site</div>

    <mat-table [dataSource]="changesMembnersDataSource" style='height:200px; overflow:auto; margin: 10px 0 0 0;'>

      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef> Data </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.timestamp | date: 'dd/MM/yyyy'}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.name }}
        </mat-cell>
      </ng-container>

      <!-- edit Column -->
      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='openChangesDialog(element)' style='background-color: whitesmoke;'>
            <mat-icon class='icon-info' style='font-size:1.5em;'>
              info_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>

      <mat-header-row class='mat-header-row' *matHeaderRowDef="changesMermbersColumns">
      </mat-header-row>

      <mat-row *matRowDef="let row; columns: changesMermbersColumns;">
      </mat-row>

    </mat-table>
    <!-- END TABLE -->
  </mat-card>


  <mat-card>
    <h4 style="color:rgba(0,0,0, .7);">
      Atualizações de Dados (Staff)
    </h4>


    <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>star_outline</mat-icon>
          <div>Enviadas pelos colaboradores</div>
        </ng-template>

        <div class='content'>

          <!-- TABLE -->
          <mat-table [dataSource]="dataSourceMemberTemp" style="height:260px;">

            <ng-container matColumnDef="mt_updatedDate">
              <mat-header-cell *matHeaderCellDef> Data </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span>
                  {{ element.dateCreated.seconds*1000 | date: 'dd/MM/yyyy' }}
                </span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="mt_name">
              <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="edit">
              <mat-header-cell *matHeaderCellDef> </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)='openDialogMemberChanged(element)' style='background-color: whitesmoke;'>
                  <mat-icon class='icon-info' style='font-size:1.5em;'>
                    info_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <!-- Header -->
            <mat-header-row *matHeaderRowDef="displayedColumnsMemberTemp"></mat-header-row>

            <!-- Row -->
            <mat-row *matRowDef="let row; columns: displayedColumnsMemberTemp;"></mat-row>

          </mat-table>
          <!-- END TABLE -->

        </div>

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>star</mat-icon>
          <div>Atualizadas no cadastro</div>
        </ng-template>

        <div class='content'>

          <!-- TABLE -->
          <mat-table [dataSource]="dataSourceMemberTempMoved" style="height:260px;">

            <ng-container matColumnDef="mt_updatedDate">
              <mat-header-cell *matHeaderCellDef> Data </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span>
                  {{ element.dateUpdated.seconds*1000 | date: 'dd/MM/yyyy' }}
                </span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="mt_name">
              <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="edit">
              <mat-header-cell *matHeaderCellDef> </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)='openDialogMemberChanged(element)' style='background-color: whitesmoke;'>
                  <mat-icon class='icon-info' style='font-size:1.5em;'>
                    info_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <!-- Header -->
            <mat-header-row *matHeaderRowDef="displayedColumnsMemberTemp"></mat-header-row>

            <!-- Row -->
            <mat-row *matRowDef="let row; columns: displayedColumnsMemberTemp;"></mat-row>

          </mat-table>
          <!-- END TABLE -->

        </div>

      </mat-tab>

    </mat-tab-group>


  </mat-card>

  <br>

  <mat-card>
    <mat-select style='font-weight: bold;' (ngModelChange)='selectOrdersByProduct($event)'
      [ngModel]='selectedProduct.id' placeholder="Selecione um produto">
      <mat-option *ngFor="let product of arrayProducts" [value]="product.id">
        {{ product.name }}
      </mat-option>
    </mat-select>
  </mat-card>

  <mat-card>

    <div>

      <div class='card-title'>Lista de espera</div>

      <!-- TABLE -->
      <mat-table style='max-height: 160px; overflow: auto;' [dataSource]="_dashService.waitingDataSource" matSort
        matSortDisableClear='true'>

        <!-- Icon Column -->
        <ng-container matColumnDef="icon">
          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-icon style='font-size:1.2em; margin-top:10px;'>apps</mat-icon>
          </mat-cell>
        </ng-container>

        <!-- Product Column -->
        <ng-container matColumnDef="product">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Produto </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.product_name }} </mat-cell>
        </ng-container>

        <!-- Member Column -->
        <ng-container matColumnDef="member">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Usuário </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.member_name }} </mat-cell>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Liberado </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span *ngIf='element.allowed'>
              <img src='/assets/images/status/img_green.png'>
            </span>
          </mat-cell>
        </ng-container>

        <!-- Header -->
        <mat-header-row *matHeaderRowDef="_dashService.waitingDisplayedColumns"></mat-header-row>

        <!-- Row -->
        <mat-row *matRowDef="let row; columns: _dashService.waitingDisplayedColumns;"></mat-row>

      </mat-table>
      <!-- END TABLE -->

      <div class='card-title'>Reembolso</div>

      <!-- TABLE -->
      <mat-table style='max-height: 180px; overflow: auto; margin-bottom: 2px;'
        [dataSource]="_dashService.refundDataSource" matSort matSortDisableClear='true'>

        <!-- Icon Column -->
        <ng-container matColumnDef="icon">
          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-icon style='font-size:1.2em; margin-top:10px;'>apps</mat-icon>
          </mat-cell>
        </ng-container>

        <!-- Product Column -->
        <ng-container matColumnDef="product">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Produto </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.product_name }} </mat-cell>
        </ng-container>

        <!-- Member Column -->
        <ng-container matColumnDef="member">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Usuário </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.member_name }} </mat-cell>
        </ng-container>

        <!-- Date Column -->
        <ng-container matColumnDef="date">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Solicitado </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span *ngIf='element.refund'>
              {{ element.refund.dateRequest.seconds*1000 | date: "dd/MM/yyyy"}}
            </span>
          </mat-cell>
        </ng-container>

        <!-- Header -->
        <mat-header-row *matHeaderRowDef="_dashService.refundDisplayedColumns"></mat-header-row>

        <!-- Row -->
        <mat-row *matRowDef="let row; columns: _dashService.refundDisplayedColumns;"></mat-row>

      </mat-table>
      <!-- END TABLE -->

      <!--
      <div class='card-title'>Origem das inscrições</div>

      <div *ngFor='let pieChart of _dashService.originPieCharts'>
        <google-chart [data]="pieChart"></google-chart>
      </div>

      -->
    </div>

  </mat-card>

</div>